define('imovel-controller',["qrcode-angular"], function() {

    var app = angular.module('imovel.controller', [
        'imovel.resource',
        'djds4rce.angular-socialshare',
        'vcRecaptcha',
        'datePicker',
        'anchor.service',
        'ja.qr'
    ]);

    app.directive('imageT', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var config = angular.extend({
                });
                var elHeight = element.height();
            }
        };
    });

    app.controller('ImovelController', ['$scope', '$filter','$timeout', '$q', '$rootScope',  'Imovel',    "$window",  "$mdDialog", "$location", "$httpParamSerializer", "vcRecaptchaService", "$sce",
        function($scope, $filter, $timeout, $q, $rootScope, Imovel, $window,  $mdDialog, $location, $httpParamSerializer, vcRecaptchaService, $sce) {
            $("#ajaxbloq").fadeIn();

            $scope.imoveis = [];
            $scope.bairros = [];
            $scope.changePesquisa = false;
            $scope.imoveisFiltro = [];
            $scope.pageIni = true;
            $scope.styleGrid = true;
            $scope.styleList = false;

            //$scope.imobl_busca_composta = imobl_busca_composta;

            if(imobl_listaimovel == 'L'){
                $scope.styleGrid = false;
                $scope.styleList = true;
            };

            $scope.makeGrid = function(){
                $scope.styleGrid = true;
                $scope.styleList = false;
            };

            $scope.makeList = function(){
                $scope.styleGrid = false;
                $scope.styleList = true;
            };

            if (bairros && bairros.length > 0 && $scope.bairros.length == 0) {
                $scope.bairros = angular.copy(bairros);
            }

            /* - FUNCAO RESPONSAVEL POR REALIZAR A PESQUISA - */

            var qtdTotalImoveis = function(){
                var qtd = 0;
                _.forEach($scope.imoveis, function(i){
                    _.forEach(i, function(j){
                        qtd++;
                    });
                });
                return qtd;
            }

            $scope.siteF = {
                searchBairros: ''
            };
            $scope.filtroBairro = function(item) {
                if (!$scope.siteF.searchBairros)
                    return true;
                var text = item.imo_bairro.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                var search = $scope.siteF.searchBairros.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                return text.indexOf(search) > -1;
            };

            $scope.pesquisa = function() {

                setTimeout(function() {
                    $("#listar-loader").addClass('active');
                    $(".building-list").addClass('loading-wrap');
                }, 0);
                if ($scope.filtro.cidade != '') {
                    Imovel.getBairro($scope.filtro.cidade, '').then(function(bairros) {

                        $scope.bairros.splice(0, $scope.bairros.length);
                        _.forEach(bairros, function(bairro) {
                            if (bairro.imo_bairro !== null) {
                                if (bairro.imo_bairro.length > 0) {
                                    $scope.bairros.push(bairro);
                                }
                            }
                        });
                    });
                }
                /**
                 * FOI COMENTADO ESE CAMPO POIS QUANDO
                 * UMA PESSOA REALIZA UMA PESQUIZA NOSITE
                 * E FAZ SCROLL ELE DESOBENECE O FILTRO
                 * PORQUE E ESCLUIDO EM ESE CAMPO.. FEITO DIA 19-12-2018 - By Steeve
                if ($scope.filtro.filter) {
                    delete $scope.filtro.filter;
                }
                if ($scope.filtro.onlycod) {
                    delete $scope.filtro.onlycod;
                }
                */
                Imovel.getImovel($scope.filtro).then(function(result) {                                        
                    if (result.length == 0) {
                        $scope.varBloq = true;
                    }
                    if (result.length > 0) {
                        if ($scope.imoveis.length == 0) {
                            $scope.imoveis = _.union($scope.imoveis, _.chunk(result, 3));
                        } else {
                            $scope.imoveis = _.flatten($scope.imoveis);
                            $scope.imoveis = $scope.imoveis.concat(result);
                            const seen = new Set();
                            $scope.imoveis = $scope.imoveis.filter(item => {
                                const k = item.imo_codigo;
                                if (seen.has(k)) {
                                    return false;
                                } else {
                                    seen.add(k);
                                    return true;
                                }
                            });
                            $scope.imoveis = _.chunk($scope.imoveis, 3);
                        }
                        $scope.blockBairroPesquisa = false;

                        $timeout(function() {
                            $("#listar-loader").removeClass('active');
                            $(".building-list").removeClass('loading-wrap');
                            $(".nothing-found").addClass('ativaoBagarai');
                        }, 1000);

                        if (result.length > 0) {
                            $scope.count = result[0].rowcount;
                        } else {
                            $scope.count = 0;
                        }
                        $scope.pageIni = false;
                    } else {
                        $scope.blockBairroPesquisa = false;
                    }

                })['catch'](function(e) {
                    $("#ajaxbloq").fadeOut();
                });
            };

            $scope.inicializaFiltro = function() {
                $scope.count = 0;
                $scope.filtro = {
                    operacao: '',
                    codigo: [],
                    tipoimovel: '',
                    imos_codigo:'',
                    subtipoimovel: [],
                    empreendimento: '',
                    destaque: false,
                    vlini: '',
                    vlfim: '',
                    exclusivo: false,
                    cidade: '',
                    pais: '1',
                    filtropais: true,
                    order: imobl_ordemimovel ? imobl_ordemimovel : '',
                    limit: 9,
                    page: 0,
                    imoveisRows: [],
                    imoveisBusca: [],
                    bairros: []
                };
                if (bairrosSelecionados && bairrosSelecionados.length > 0 && $scope.filtro.bairros.length == 0) {
                    _.forEach(bairrosSelecionados, function(b) {
                        $scope.filtro.bairros.push(b);
                    });
                }
            }
            $scope.inicializaFiltro();

            var serialize = function(obj) {
                var str = [];
                for(var p in obj) {
                    if (obj.hasOwnProperty(p) && p != 'subtipoimovel') {
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    }
                    if (p == 'subtipoimovel') {
                        str.push(encodeURIComponent(p) + "=" + obj[p]);
                    }
                }
                return str.join("&");
            }
            var unserialize = function(search){
                return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
            }

            $scope.changeFiltro = function(vl, tp) {
                console.log("ENTROU AQUI e esta pesquisando o imobl_ordemimovel")
                $scope.filtro.page = 0;
                $scope.imoveisRows = [];
                $scope.changePesquisa = true;
                $scope.blockBairroPesquisa = true;
                var filtro = $scope.filtro;
                $scope.filtro.filtropais = false;
                switch (tp) {
                    case 'ttpr_codigo':
                        filtro.operacao = vl;
                        filtro.ttpr_codigo = vl;

                        $('input[name="ttpr_codigo"]').each(function(i, e){
                            $(e).prop('checked',false);
                        });
                        
                        $scope.operacao = $scope.filtro.operacao ? $scope.filtro.operacao-1 : 0;
                        $scope.rangeSliderMax = parseInt($scope.filtros.tblpreco[$scope.operacao].maxval);
                        $scope.rangeMaxVal = $scope.rangeSliderMax;
                        filtro.vlini = '';
                        filtro.vlfim = '';
                        break;
                    case 'imocon_codigo':
                        filtro.empreendimento = vl;
                        break;
                    case 'cid_codigo':
                        filtro.cidade = vl;                        
                        if (filtro.bairros.length > 0) filtro.bairros.splice(0, filtro.bairros.length);
                        break;
                    case 'pais_codigo':                        
                        $scope.filtro.filtropais = true;
                        filtro.pais = vl;
                        break;                        
                    case 'bairro':
                        var idx = _.findIndex(filtro.bairros, function(r) {
                            return r == vl
                        });
                        if (idx == -1) {
                            filtro.bairros.push(vl);
                        } else {
                            filtro.bairros.splice(idx, 1);
                        }
                        break;
                    case 'tic_codigo':
                        filtro.tipoimovel = vl;
                        filtro.subtipoimovel = [];
                        break;
                    case 'imos_codigo':
                        filtro.imos_codigo = vl;
                        break;
                    case 'ist_codigo':
                        filtro.tipoimovel = '';
                        var idx = _.findIndex(filtro.subtipoimovel, function(r) {
                            return r == vl
                        });
                        if (idx == -1) {
                            if (imobl_busca_composta) {
                                filtro.subtipoimovel.push(vl);
                            } else {
                                filtro.subtipoimovel = [];
                                filtro.subtipoimovel.push(vl);
                            }
                        } else {
                            filtro.subtipoimovel.splice(idx, 1);
                        }
                        break;
                    case 'order':
                        filtro.order = vl;
                        break;
                    default:
                        break;
                }
                $scope.rangeMinVal = $scope.filtro.vlini;
                $scope.rangeMaxVal = $scope.filtro.vlfim;
                var obj = angular.copy(filtro);
                if (obj.subtipoimovel.length > 0) {
                    obj.subtipoimovel = obj.subtipoimovel.join(',');
                }
                $location.search(obj);
                $scope.imoveis = [];
                $scope.pesquisa();                
            };



            if ($location.search()) {
              if ($location.search().empreendimento) {
                var urlEmpreendimento = $location.search().empreendimento;
                $scope.lotes = [];
                Imovel.getLotes(urlEmpreendimento).then(function(lotes) {
                    _.forEach(lotes, function(lote) {
                        if (lote.imo_lote !== null) {
                            $scope.lotes.push(lote);
                        }
                    });
                });
              }
              if ($location.search().lote) {
                var urlLote = $location.search().lote;
                $scope.quadras = [];
                Imovel.getQuadras(urlEmpreendimento, urlLote).then(function(quadras) {
                    _.forEach(quadras, function(quadra) {
                        if (quadra.imo_quadra !== null) {
                            $scope.quadras.push(quadra);
                        }
                    });
                });

              }
            }

            $scope.carregaLote = function(condominio) {
                $scope.lotes = [];
                $scope.quadras = [];
                $scope.filtro.lote = '';
                $scope.filtro.quadra = '';
                Imovel.getLotes(condominio).then(function(lotes) {
                    _.forEach(lotes, function(lote) {
                        if (lote.imo_lote !== null) {
                            $scope.lotes.push(lote);
                        }
                    });
                });

            }

            $scope.carregaQuadra = function(condominio, lote) {
                $scope.filtro.quadra = '';
                $scope.quadras = [];
                Imovel.getQuadras(condominio, lote).then(function(quadras) {
                    _.forEach(quadras, function(quadra) {
                        if (quadra.imo_quadra !== null) {
                            $scope.quadras.push(quadra);
                        }
                    });
                });
            }

            $scope.pes = '';
            $scope.checkInterval = function(obj, cod) {
                // console.log('Data de impresao',$scope.valuePreco);
                if ($scope.pes != cod) {
                    $scope.pes = cod;
                    if ((obj.min || obj.min == 0) && obj.max ) {
                        $scope.filtro.vlfim = obj.max.toFixed(2);
                        $scope.filtro.vlini = obj.min.toFixed(2);
                    }
                } else {
                    $scope.filtro.vlfim = '';
                    $scope.filtro.vlini = '';
                    $scope.pes = '';
                    $('input[name="ttpr_codigo"]').each(function(i, e){
                        $(e).prop('checked',false);
                    });
                }
                $scope.changeFiltro();
                $scope.updateSliderVal('min');
            }

            $scope.getUrl = function(){
                var obj = $location.search();
                if(obj.search){
                    obj = unserialize(window.atob(obj.search));
                }
                _.forEach(obj, function(o, key){
                    if(key == 'subtipoimovel') {
                               _.forEach(o.split(','), function (r) {
                                   $scope.filtro[key].push(r);
                               })
                    }else if(key == 'page'){
                        /*
                         Logica para a page do tipo pagination
                         */
                        $scope.filtro['page'] = 0;
                    }
                    else {
                        $scope.filtro[key] = o;
                    }
                });
            }
            $scope.getUrl();

            if(count > 0){
                $scope.imoveis = imoveis;
                $scope.count =  count;
            }

            $scope.checkTicList = function(tic_codigo){
               return ($scope.filtro.tipoimovel == tic_codigo) ? true : false;
            }
            $scope.checkTipoCadastro = function(ist_codigo){
                var idx = _.findIndex($scope.filtro.subtipoimovel, function(r){
                    return r == ist_codigo;
                });
                if(idx == -1){
                    return false;
                }else{
                    return true;
                }
            };

            $scope.checkBairro = function(imo_bairro) {

                if (typeof $scope.filtro.bairros == 'string') {
                    $scope.filtro.bairros = [$scope.filtro.bairros];
                }

                var idx = _.findIndex($scope.filtro.bairros, function(r) {
                    return r == imo_bairro;
                });
                if (idx == -1) {
                    return false;
                } else {
                    return true;
                }
            };

            $scope.valuePreco = {};
            $scope.dataPreco = function(){
                $scope.valorinicial = $filter('currency')($scope.filtro.vlini,'');
                $scope.valorfinal = $filter('currency')($scope.filtro.vlfim,'');
                $scope.valuePreco.preco =  $scope.valorinicial+$scope.valorfinal;
            }
            $scope.dataPreco();

            $scope.changeImovel = function($select){
                Imovel.getImovelFiltro($select.search).then(function (result) {
                    $scope.imoveisFiltro = result;
                });
            }

            /*
             SCROLLING
             */
            var windowEl = angular.element($window);
            var time;
            $scope.tabScroll = 'imovel';
            windowEl.on('scroll', function(el, idx){
                    if($scope.tabScroll == 'imovel') {
                        if ($scope.imoveis.length > 0) {
                            if (qtdTotalImoveis() < $scope.count) {
                                var ls = $(".list-more").offset().top;
                                var h = $(window).height();
                                if ($(window).scrollTop() >= ls - h) {
                                    $timeout.cancel(time);
                                    time = $timeout(function () {
                                        $scope.filtro.page++;
                                        //$location.search('search='+window.btoa(serialize($scope.filtro)));
                                        $location.search($scope.filtro);
                                        $scope.pesquisa();
                                    }, 500);
                                }
                            }
                        }
                    }else{
                        if(!$scope.nomoreClassificados) {
                            var ls = $(".list-more").offset().top;
                            var h = $(window).height();
                            if ($(window).scrollTop() >= ls - h) {
                                $timeout.cancel(time);
                                time = $timeout(function () {
                                    $scope.pesquisa();
                                    $scope.getGeminidas();
                                }, 500);
                            }
                        }
                }
            });
            $scope.listObjClassificados = [];
            $scope.classificados = [];
            $scope.tblPrecos = (filtro.tblpreco) ? filtro.tblpreco : [];
            $scope.tipoCadastro = (filtro.tipoCadastro) ? filtro.tipoCadastro : [];
            $scope.montaObjListaClassificados = function(){
                var qtd = $scope.classificados.length;
                var maxVl = $scope.maxClassificados;
                var minVl = 0;//$scope.minClassificados;
                var qtdList = 10;//(parseInt(maxVl/minVl) <= 0) ? 1 : (parseInt(parseInt(maxVl/minVl) / 2) <= 0) ? 1 : parseInt(maxVl/minVl) / 2;
                var vlPorList = maxVl / qtdList;
                var objList = [];
                var min = minVl;
                var max = vlPorList;
                var max = 200000;
                var min = 0;
                for(var i = 0; max <= 1000000; i++){
                    var obj = {min:min, max:max, imoveis:[]};
                    objList.push(obj);
                    min = max;
                    max = max + 200000;
                }
                var obj = {min:min, max:(maxVl > max) ? maxVl : max, imoveis:[]};
                objList.push(obj);
                var  arrImovel = [];
                var arrMyImovel = [];
                var newArrMyImovel = [];
                objList.map(function(vl, idx){
                    arrImovel = _.filter($scope.classificados, function(o){return parseFloat(o.data.price) <= parseFloat(vl.max) && parseFloat(o.data.price) > parseFloat(vl.min);});
                    _.forEach($scope.filtro.imoveisBusca, function(o){
                        var nometabela = false;
                        var valortabela = 0;
                        _.forEach(o.tabeladepreco, function(tbl){
                            (!nometabela) ? nometabela = tbl.ttpr_nome  : nometabela + '/' + tbl.ttpr_nome;
                        });
                        var idx = _.findIndex(arrMyImovel, function(o2){return o2.imo_codigo == o.imo_codigo});
                        if(idx == -1) {
                            var obj = {
                                data: {
                                    type: o.tic_nome,
                                    subtype: o.ist_nome,
                                    name: o.imo_codigo + " - " + o.tic_nome + " " + o.ist_nome,
                                    neighborhood: o.imo_bairro,
                                    operation: nometabela,
                                    price: o.max
                                },
                                my: true,
                                imo_codigo: o.imo_codigo
                            };
                            arrMyImovel.push(obj);
                        }
                    });
                    newArrMyImovel = _.filter(arrMyImovel, function(o){return parseFloat(o.data.price) <= parseFloat(vl.max) && parseFloat(o.data.price) >= parseFloat(vl.min);});
                    _.forEach(newArrMyImovel, function(obj){
                        arrImovel.push(obj);
                    });
                    vl.imoveis = arrImovel;
                });
                $scope.listObjClassificados = objList;
            }
            $scope.maxClassificados = 0;
            $scope.minClassificados = 0;
            $scope.nomoreClassificados = false;
            $scope.filtroOrdem = 'min';
            $scope.countGeminidas = 0;
            $scope.getGeminidas = function(){
                var uuid = [];
                if($scope.classificados.length > 0) {
                    _.forEach($scope.classificados, function (o) {
                        uuid.push(o.uuid);
                    });
                }
                /*
                     Tabela de Preco Name
                 */
                var obj = {
                    limit:150,
                    offset:  $scope.classificados.length ,
                    filtro:angular.copy($scope.filtro)
                }
                /*
                     Segue logica implementada para o geminidas
                     Ex: NOMETIPO NOMESUBTIPO
                     collection gem_produtct_type -> from : pega o type e subtype
                     depois busca collection gem_product_data -> type e subtype
                 */
                if(obj.filtro.operacao != null){
                    var idx = _.findIndex($scope.tblPrecos, function(r){return r.ttpr_codigo == parseInt(obj.filtro.operacao)});
                    obj.filtro.operacaonome = (idx != -1) ? $scope.tblPrecos[idx].ttpr_nome : null;
                }
                if(filtro.imos_status != null){
                    var idx = _.findIndex(obj.filtro.imos_status, function(r){return r.imos_codigo == parseInt(obj.filtro.imos_codigo)});
                    obj.filtro.operacaonome = (idx != -1) ? $scope.tblPrecos[idx].ttpr_nome : null;
                }
                obj.filtro.tipoimovelnome = null;
                if(obj.filtro.tipoimovel != null){
                    var idx = _.findIndex($scope.tipoCadastro, function(r){return r.tic_codigo == parseInt(obj.filtro.tipoimovel)});
                    if(idx!=-1)
                    obj.filtro.tipoimovelnome = $scope.tipoCadastro[idx].tic_nome;
                }
                obj.filtro.subtipoimovelnome = [];
                if(obj.filtro.subtipoimovel.length > 0){
                    _.forEach($scope.tipoCadastro, function(r1, idx1){
                        _.forEach(obj.filtro.subtipoimovel, function(ist_codigo){
                            var idx = _.findIndex(r1.ImovelSubtipo, function(r){return r.ist_codigo == ist_codigo});
                            if(idx != -1){
                                obj.filtro.subtipoimovelnome.push(r1.tic_nome+' '+r1.ImovelSubtipo[idx].ist_nome);
                            }
                        });

                    });
                }
                if(obj.filtro.order == 'maxval'){
                    $scope.filtroOrdem = '-max';
                }else{
                    $scope.filtroOrdem = 'min';
                }
                Imovel.getGeminidas(obj).then(function(result){
                    $scope.countGeminidas = result.data.count;
                    if(result.data.items.length == 0){
                        $scope.nomoreClassificados = true;
                    }
                    _.forEach(result.data.items, function(vl){
                        var idx = _.findIndex(uuid, function(o){return o == vl.uuid});
                        if(idx == -1) {
                            $scope.classificados.push(vl);
                        }
                    });
                    $scope.maxClassificados = result.data.maxValue;
                    $scope.minClassificados = result.data.minValue;
                    $scope.montaObjListaClassificados();
                })
            }
            $scope.getGeminidas();
            $scope.resetEmailClassificados = function(){
                $rootScope.classificado = {
                    email:null,
                    nome:null,
                    obs:'Gostaria de solicitar mais informações sobre este(s) imóvel(is), Obrigado!',
                    telefone:null,
                    responserecaptcha:null,
                    imovel:[]
                }
            };
            $scope.resetEmailClassificados();
            $scope.chkClassificados = function(item){
                var idx = _.findIndex($rootScope.classificado.imovel, function(o){
                    return o.uuid == item.uuid
                });
                if(idx != -1){
                    return true
                }else{
                    return false
                }
            }
            $scope.chekRootClassificados = function(){
                return $rootScope.classificado.imovel.length;
            }
            $scope.addImovelClassificado = function(item){
                var idx = _.findIndex($rootScope.classificado.imovel, function(o){
                    return o == item
                });
                if(idx == -1){
                    if( $rootScope.classificado.imovel.length <= 10) {
                        $rootScope.classificado.imovel.push(item);
                    }else{
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.body))
                                .clickOutsideToClose(true)
                                .title('Atenção!')
                                .textContent('Você já adicionou muitos imóveis para esta operação, tente enviar primeiro este depois repita o processo!')
                                .ariaLabel('Atenção!')
                                .ok('Ok')
                        );
                    }
                }
            }
            $scope.removeImovelClassificado = function(item){
                var idx = _.findIndex($rootScope.classificado.imovel, function(o){
                    return o.uuid == item.uuid
                });
                $rootScope.classificado.imovel.splice(idx, 1);
            }
            var DialogController = ["$scope", "$rootScope", "$mdDialog", "vcRecaptchaService", "Imovel", function($scope, $rootScope, $mdDialog, vcRecaptchaService, Imovel) {

                $scope.classificado = {};
                angular.merge($scope.classificado, $rootScope.classificado);
                $scope.resetEmailClassificados = function(){
                    $rootScope.classificado = {
                        email:null,
                        nome:null,
                        obs:'Gostaria de solicitar mais informações sobre este(s) imóvel(is), Obrigado!',
                        telefone:null,
                        responserecaptcha:null,
                        imovel:[]
                    }
                };
                $scope.hide = function() {
                    $mdDialog.hide();
                };
                $scope.cancel = function() {
                    $mdDialog.cancel();
                };
                $scope.answer = function(answer) {
                    $mdDialog.hide(answer);
                };
                /*
                 Recaptcha
                 */
                $scope.response = null;
                $scope.widgetId = null;
                $scope.recaptcha = {
                    key: '6Le2PxkTAAAAABJWPWIkLPa9QJ-J40XaiZkANGTC'//chave do cliente de segurança
                };
                $scope.setResponse = function (response) {
                    $scope.classificado.responserecaptcha = response;
                };
                $scope.setWidgetId = function (widgetId) {
                    $scope.widgetId = widgetId;
                };
                $scope.cbExpiration = function() {
                    vcRecaptchaService.reload($scope.widgetId);
                    $scope.classificado.responserecaptcha = null;
                };
                $scope.msgSucess = '';
                $scope.msgError = '';
                $scope.resolveCaptcha = true;
                $scope.enviaClassificados = function(form){
                    if($scope.classificado.responserecaptcha == "" || $scope.classificado.responserecaptcha == null){
                        $scope.resolveCaptcha = false;
                        return false;
                    } else {
                        $scope.resolveCaptcha = true;
                        if (form.$valid) {
                            Imovel.enviaClassificados($scope.classificado).then(function(result){
                                //console.log(result);
                                if(result.data.success){
                                    $mdDialog.show(
                                        $mdDialog.alert()
                                            .parent(angular.element(document.body))
                                            .clickOutsideToClose(true)
                                            .title('Obrigado!')
                                            .textContent('Obrigado, logo entraremos em contato com mais informações.')
                                            .ariaLabel('Obrigado!')
                                            .ok('Ok')
                                    );
                                    $scope.hide();
                                    $scope.resetEmailClassificados();
                                }else{
                                    $mdDialog.show(
                                        $mdDialog.alert()
                                            .parent(angular.element(document.body))
                                            .clickOutsideToClose(true)
                                            .title('Atenção!')
                                            .textContent(result.data.msg)
                                            .ariaLabel('Atenção!')
                                            .ok('Ok')
                                    );
                                }
                            });
                        }else{
                            angular.forEach(form.$error.required, function (value, key) {
                                form.$error.required[key].$pristine = false;
                            });
                        }
                    }
                }
            }];
            $scope.openModalClassificados = function(){
                $rootScope.gotoTop();
                if($rootScope.usuarioLogado){
                    $rootScope.classificado.email = $rootScope.usuarioLogado.usu_email;
                }
                $mdDialog.show({
                        controller: DialogController,
                        templateUrl: '/site/public/includes/modal/imovel-email-classificados.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:true,
                        fullscreen: false
                    })
                    .then(function(answer) {
                        $scope.status = '';
                    }, function() {
                        $scope.status = '';
                    });
            }
            $scope.changeTab = function(name){
                $scope.tabScroll = name;
            }

            function check(){
                if($scope.filtros){
                    clearInterval(checkingInterval)
                    $scope.setRangeSlider();
                }
            }

            var checkingInterval = setInterval(check, 1000);
            
            $scope.setRangeSlider = () => {
                let brReal = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });
                
                $scope.rangeSliderMin = 0;
                $scope.operacao = $scope.filtro.operacao ? $scope.filtro.operacao-1 : 0;
                $scope.rangeSliderMax = parseInt($scope.filtros.tblpreco[$scope.operacao].maxval);
                // Único jeito que encontrei para que os campos de valor mínimo e máximo fossem preenchidos e o slider funcionasse corretamente
                // Foi duplicar estas duas linhas abaixo para dentro e fora da função construtora do slider.
                // # Caso for encontrado outro método favor atualizar, pois não está das melhores formas :(
                var startMinVal = $scope.rangeSliderMin;
                var startMaxVal = $scope.rangeSliderMax; 
                $scope.rangeMinVal = $scope.filtro.vlini && $scope.filtro.vlini != '' ? $scope.filtro.vlini : startMinVal;
                $scope.rangeMaxVal = $scope.filtro.vlfim && $scope.filtro.vlfim != '' ? $scope.filtro.vlfim : startMaxVal;
                $(function () {
                    $scope.rangeMinVal = $scope.filtro.vlini && $scope.filtro.vlini != '' ? $scope.filtro.vlini : startMinVal;
                    $scope.rangeMaxVal = $scope.filtro.vlfim && $scope.filtro.vlfim != '' ? $scope.filtro.vlfim : startMaxVal;
                    $("#slider-range").slider({
                        //   orientation: "vertical",
                        range: true,
                        min: $scope.rangeSliderMin,
                        max: $scope.rangeSliderMax,
                        step: $scope.filtro.operacao == 1 ? 500 : 1,
                        values: [$scope.rangeMinVal, $scope.rangeMaxVal],
                        slide: function (event, ui) {
                            $scope.rangeMinVal = ui.values[0];
                            $scope.rangeMaxVal = ui.values[1];
                        },
                        change: function (event, ui) {
                            $scope.filtro.vlini = $scope.rangeMinVal;
                            $scope.filtro.vlfim = $scope.rangeMaxVal;
                            $scope.changeFiltro();
                        }
                    });
                    // $scope.rangeMinVal = $("#slider-range").slider("values", 0);
                    // $scope.rangeMaxVal = $("#slider-range").slider("values", 1);
                });
                $("#amountMin").val(brReal.format($scope.rangeMinVal));
                $("#amountMax").val(brReal.format($scope.rangeMaxVal));
            };
            
            $scope.updateSliderVal = (elem) => {
                // Conversão dos números para float.
                $scope.rangeMinVal = isNaN($scope.rangeMinVal) ? null : parseFloat($scope.rangeMinVal);
                $scope.rangeMaxVal = isNaN($scope.rangeMaxVal) ? null : parseFloat($scope.rangeMaxVal);
                if ($scope.rangeMinVal > $scope.rangeMaxVal && elem == 'min') { $scope.rangeMinVal = $scope.rangeMaxVal; // console.log('Valor mínimo não deve ser maior que o máximo')
             }
                // Valor máximo não deve ser menor que o mínimo
                if ($scope.rangeMaxVal < $scope.rangeMinVal && elem == 'max') { $scope.rangeMaxVal = $scope.rangeMinVal;  // console.log('Valor máximo não deve ser menor que o mínimo')
            };
                // Caso valor máximo ultrapasse o limite, o limite se torna o valor máximo
                if ($scope.rangeMaxVal > $scope.rangeSliderMax) { $scope.rangeSliderMax = $scope.rangeMaxVal; $("#slider-range").slider( "option", "max", $scope.rangeMaxVal );;  // console.log('Valor máximo não deve ultrapassar o limite')
            };
                // Valor mínimo não deve ultrapassar o limite
                if ($scope.rangeMinVal < $scope.rangeSliderMin) { $scope.rangeMinVal = $scope.rangeSliderMin;  // console.log('Valor mínimo não deve ultrapassar o limite')
            };
                // Valores não podem ser nulos ou NaN
                if ((isNaN($scope.rangeMinVal) || !$scope.rangeMinVal)) {
                    $scope.rangeMinVal = $scope.rangeSliderMin
                    // console.log('Valores não podem ser nulos ou NaN')
                }
                if ((isNaN($scope.rangeMaxVal) || !$scope.rangeMaxVal)) {
                    $scope.rangeMaxVal = $scope.rangeSliderMax
                    // console.log('Valores não podem ser nulos ou NaN')
                }
                $("#slider-range").slider("values", [$scope.rangeMinVal, $scope.rangeMaxVal]);
            }
        }]);

    app.controller('ImovelExibirController', ['$scope', '$rootScope',  'Imovel',  "$location", "$timeout",  "vcRecaptchaService", "anchorSmoothScroll", "$FB", "$sce", '$metadata', "$window",
        function($scope, $rootScope,  Imovel, $location, $timeout, vcRecaptchaService, anchorSmoothScroll, $FB, $sce, $metadata,$window) {
            $scope.urlCompartilhar = $location.absUrl();
            $scope.qrCode = $scope.urlCompartilhar;
            $scope.standing = false;
            $scope.imovel = imovel;
            $scope.activeCategory  = activeCategory;
            $scope.mapa = 'mapa';
            $scope.siteUrl = imovel.og.url;
            $scope.btnReservarChave = true;
            $scope.createSolicitacaoModal = false;
            $scope.showEsteira =       $scope.imovel.showEsteira && $scope.imovel.valor_locacao_ativo && !$scope.imovel.locado && $scope.imovel.imo_ativo && $scope.imovel.imos_nome!='Alugado';
            $scope.showEsteiraLogout = $scope.showEsteira;
            $scope.setupFormSolicitacao = function(){

                $scope.formAtual = 'solicitacao';
                $scope.formName = 'Solicitação chave';
                $scope.chaves = [];
                $scope.motivos_retirada = [];

                $scope.showDataRetirada = false;
                $scope.showDataReserva = true;

                $scope.selectedTipoSolicitacao = 'RESERVA';
                $scope.selectedMotivoRetirada = null;
                $scope.selectedChave = null;
                $scope.so_data_retirada = null;
                $scope.so_data_reserva = null;
                $scope.so_data_devolucao = null;
                $scope.solicitacaoEnviada = false;
                $scope.usuario = null;
                $scope.so_descricao = null
                $scope.selectedLocal = null
            };

            $scope.setupFormSolicitacao();

            $scope.solicitarChave = function(){
                $scope.solicitacaoEnviada = false;
                Imovel.getChaves({imo_codigo: imovel.imo_codigo}).then(function (response) {
                    if(response.data && response.data.chaves && response.data.chaves.length > 0){
                        $scope.formAtual = 'solicitacao';
                        $scope.formName = 'Solicitação chave';
                        $scope.createSolicitacaoModal = true;
                        $scope.chaves = response.data.chaves;
                        $scope.motivos_retirada = response.data.motivos_retirada;
                        $scope.usuario = response.data.usuarioLogado.usu_codigo;
                        $scope.locais = response.data.locais;
                    }else{
                        alert('Esse imóvel não possui chaves disponíveis no momento...\n' + 'Faça contato conosco para mais informações !');
                    }
                }).catch(function (err) {
                    console.error(err);
                });
            }


            $scope.enviarSolicitacao = function(){
                var payload = {
                    ch_codigo: 0,
                    mr_codigo: $scope.selectedMotivoRetirada,
                    so_data_reserva: $scope.so_data_reserva,
                    so_data_retirada: $scope.so_data_retirada,
                    so_data_devolucao: $scope.so_data_devolucao,
                    usu_codigo: $scope.usuario,
                    so_tipo_solicitacao: "RESERVA",
                    lc_codigo: $scope.selectedLocal,
                    so_descricao: $scope.so_descricao,
                    so_data_solicitacao: new Date(moment().format("YYYY-MM-DD[T]HH:mm:ss")),
                    imo_codigo: imovel.imo_codigo
                };

                console.log($scope);
                Imovel.saveSolicitacao(payload).then(function (response) {
                    $scope.setupFormSolicitacao();
                    $scope.solicitacaoEnviada = true;
                }).catch(function (err) {
                    console.error(err);
                });
            };


            $scope.selectTipoSolicitacao = function(tipoSolicitacao){
                $scope.selectedTipoSolicitacao = tipoSolicitacao;
                if(tipoSolicitacao == 'RESERVA'){
                    $scope.showDataRetirada = false;
                    $scope.showDataReserva = true;
                }
                if(tipoSolicitacao == 'RETIRADA'){
                    $scope.showDataRetirada = true;
                    $scope.showDataReserva = false;
                }
            };

            $scope.setModel = function(model, value){
                $scope[model] = value;
                console.log($scope[model]);
            };


            $scope.changeForm = function(form, name){
                $scope.formAtual = form;
                $scope.formName = name;
            };


            $scope.itemClicked = function ($index) {
                $scope.activeCategory = $index;
            };

            $scope.gotoElement = function (eID){
                $location.hash('bottom');
                anchorSmoothScroll.scrollTo(eID);
            };

            // var touchtime = 0;
            // $("#imovel-exibir figure").on("click", function() {
            //     if (touchtime == 0) {
            //         touchtime = new Date().getTime();
            //     } else {
            //         if (((new Date().getTime()) - touchtime) < 800) {
            //             alert("double clicked");
            //             touchtime = 0;
            //         } else {
            //             touchtime = new Date().getTime();
            //         }
            //     }
            // });


             // Mobile Nav exibir imóveis | Ruggini 19/02

            $(document).ready(function(){

                var wh = $(window).height();
                var info = $('#info').offset().top;
                var galeria = $('#galeria').offset().top;
                var video = $('#video').offset().top;
                var contato = $('#contato').offset().top;

                var inner = $('.exibir-inner').offset().top;

                $(window).scroll(function() {
                    if ($(this).scrollTop() >= inner ) {
                        console.log('desce');
                        $('#imovel-exibir .nav').addClass('fixed');
                    }
                    if ($(this).scrollTop() < inner ) {
                        $('#imovel-exibir .nav').removeClass('fixed');
                        console.log('sobe');
                    }
                });

                $(document).on('click', '#imovel-exibir .nav .link-to', function() {
                    var $dataLink = $(this).data('link');
                    $('html,body').animate({scrollTop: $($dataLink).offset().top - 49 },'slow');
                });

            });

            /* Processamento de imagem dos ví­deos de mí­dia */

            $scope.getThumbs = function(caminho) {
                var ytb = caminho.includes("youtu.be") || caminho.includes("youtube");
                if (ytb) {
                    var ytbSrc = null;
                    var regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|watch\/|.*[?&]v=)|youtu\.be\/)(?:v=)?([^"&?\/\s]{11})/i;
                    var match = caminho.match(regex);
                    if (match.length > 0) {
                        ytbSrc = 'https://i.ytimg.com/vi/' + match[1] + '/hqdefault.jpg';
                    }
                    return ytbSrc;
                } else {
                    var regExp = /(http[s]?:\/\/)?(www\.)?vimeo.com\/(\d+)($|\/)/;
                    var match = caminho.match(regExp);
                    if (match) {
                        return 'https://i.vimeocdn.com/video/' + match[3] + '_200x130.webp';
                    }
                }
            };

            $scope.renderHtml = function (htmlCode) {
                return $sce.trustAsHtml(htmlCode);
            };

            $scope.bodyHtml = $scope.imovel.iframe.length > 0 ? $scope.imovel.iframe[0].ifr_caminho: '';

            $scope.getParameterByName = function(url, name) {
                name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                    results = regex.exec(url);
                return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
            };
            /** Fim do processamento de imagens dos videos de midia */
            $scope.imoRelacionados = [];
            $scope.qrCode = '';
            //$scope.checkimovelleadpage = $rootScope.checkResponse($stateParams.imo_codigo);
            $scope.getDetalhe = function(){
                console.log('getDETALHE');
           //     $scope.checkimovelleadpage = $rootScope.checkResponse($stateParams.imo_codigo);
                if($rootScope.usuarioLogado){//se tiver lagado sempre vai ser true
                    $scope.checkimovelleadpage = true;
                }
                Imovel.getDetalhe($scope.checkimovelleadpage).then(function(result){
                    console.log(result[0]);
                    $scope.imovel = result[0];
                    $scope.objImovelMobile = $scope.getObjfotos($scope.imovel.categoriafotografia);
                    result[0].caracteristicas = JSON.parse(result[0].caracteristicas);
                    result[0].caracteristicaspersoavulsas = (result[0].caracteristicaspersoavulsas) ? JSON.parse(result[0].caracteristicaspersoavulsas) : [];
                    if(result[0].caracteristicacondominio != null){
                        result[0].caracteristicacondominio = JSON.parse(result[0].caracteristicacondominio);
                    }

                    if(result[0].videos != null) {
                        result[0].videos = JSON.parse(result[0].videos.replace(/^\s+/mg, '').replace(/\n/g, ''));
                    }else{
                        result[0].videos = [];
                    }

                    var caminho = (config.https=='true'?'https://':'http://')+$location.host()+'/uploads/imovel/'+$scope.imovel.imo_codigo+'/';
                    if($scope.imovel.fot_caminho == null){
                        caminho = (config.https=='true'?'https://':'http://')+$location.host();
                        $scope.imovel.fot_caminho = '/site/public/theme/assets/no-image.jpeg'
                    }
                    var imgs = [{img:caminho+'thumb/'+$scope.imovel.fot_caminho}];
                    if(result[0].categoriafotografia.length > 0){
                        $scope.activeCategory = result[0].categoriafotografia[0].ftc_codigo
                    }
                    $scope.verifyNegCondition($scope.imovel.tabeladepreco);//ruggini
                    $scope.qrCode = $scope.urlCompartilhar;
                    if(result[0].imoveisRelacionados != null){
                        $scope.imoRelacionados = result[0].imoveisRelacionados;
                        $scope.imoRelacionados.map(function(result2, idx2){
                            if($scope.imoRelacionados[idx2].tabeladepreco != null) {
                                $scope.imoRelacionados[idx2].tabeladepreco = JSON.parse(result2.tabeladepreco.replace(/^\s+/mg, '').replace(/\n/g, ''));
                            }
                        });
                    }else{
                        $scope.imoRelacionados = [];
                    }
                    $scope.standing = true;
                });
            }

            //$scope.getDetalhe();
            $scope.showObs = false;
            $scope.openObs = function(){
                $scope.showObs = $scope.showObs ? false : true;
            }

            $scope.changeMapa = function(tipo){
                $scope.mapa = tipo;
                if(tipo == 'streetview') {
                    $scope.changeStreetView();
                }else{
                    var obj = document.querySelector('#streetview');
                    var mapa = document.querySelector('#mapa');
                    $(obj).fadeOut(300);
                    $(mapa).fadeIn(300);
                }
            };
            $scope.changeStreetView = function(){
                var obj = document.querySelector('#streetview');
                var mapa = document.querySelector('#mapa');
                $(obj).fadeIn(300);
                $(mapa).fadeOut(300);
                var lag = new google.maps.LatLng($scope.imovel.imo_latitude, $scope.imovel.imo_longitude);
                var pov = {
                    heading: parseFloat($scope.imovel.imo_heading),
                    pitch:parseFloat($scope.imovel.imo_pitch),
                    zoom: parseFloat($scope.imovel.imo_zoom)
                };
                var _options = {
                    position:lag,
                    pov: pov
                }
                new google.maps.StreetViewPanorama(obj, _options);
            }

            /*
             CONTATO IMOVEL
             */
            $scope.contato = {
                nome: null,
                telefone:null,
                email:null,
                mensagem:null,
                cont_interese_contato: null,
                cont_concordo: false,
                recaptcharesponse:null,
                telefonetipo: "B"
            };
            $scope.msgSucess = '';
            $scope.msgError = '';

            $scope.resetForm = function(){
                $scope.contato.nome = null;
                $scope.contato.telefone = null;
                $scope.contato.email = null;
                $scope.contato.mensagem = null;
                $scope.contato.cont_interese_contato = null;
                $scope.contato.cont_concordo = false;
                $scope.contato.recaptcharesponse = null;
                $scope.contato.telefonetipo = "B";
                $timeout(function () {
                    $scope.msgSucess = '';
                    $scope.msgError = '';
                }, 8000);
            }

            $scope.msgReset = function() {
                $scope.msgSucess = '';
                $scope.msgError = '';
            }

            $scope.resolveCaptcha = true;
            $scope.enviaContatoImovel = function(form){
                if( $scope.contato.recaptcharesponse == ""){
                    $scope.resolveCaptcha = false;
                    return false;
                }else {
                    $scope.resolveCaptcha = true;
                    if (form.$valid) {
                        $("#ajaxbloq").fadeIn();
                        var obj = {
                            telefonetipo: $scope.contato.telefonetipo,
                            telefone: $scope.contato.telefone,
                            email: $scope.contato.email,
                            mensagem: $scope.contato.mensagem,
                            cont_interese_contato: $scope.contato.cont_interese_contato,
                            cont_concordo: $scope.contato.cont_concordo,
                            nome: $scope.contato.nome,
                            imovel: {
                                imo_codigo: $scope.imovel.imo_codigo,
                                tic_nome: $scope.imovel.tic_nome,
                                ist_nome: $scope.imovel.ist_nome
                            },
                            recaptcharesponse:$scope.contato.recaptcharesponse
                        };

                        //TESTAR MENSAGEM

                        // $scope.msgSucess = 'Mensagem Enviada com sucesso!';
                        // $scope.msgError = '';
                        // $scope.msgSucess = '';
                        // $scope.msgError = 'Mensagem nÃ£o pode ser enviada tente mais tarde!';
                        // form.$setPristine();
                        // $scope.resetForm();
                        // $scope.cbExpiration();


                        //    $scope.msgSucess = '';
                        // $scope.msgError = 'Mensagem nÃ£o pode ser enviada tente mais tarde!';

                        Imovel.enviaContatoImovel(obj).then(function (result) {
                            if (result.data.ok) {
                                $scope.msgSucess = 'Mensagem Enviada com sucesso!';
                                $scope.msgError = '';
                                $scope.resetForm();
                                form.$setPristine();
                                $scope.cbExpiration();
                            } else {
                                $scope.msgSucess = '';
                                $scope.msgError = 'Mensagem não pode ser enviada tente mais tarde!';
                            }
                            $scope.resetForm();
                            $("#ajaxbloq").fadeOut();
                        });


                    } else {
                        angular.forEach(form.$error.required, function (value, key) {
                            form.$error.required[key].$pristine = false;
                        });
                    }
                }
            }
            /*
             CONTATO INDIQUE
             */
            $scope.indique = {
                nomeremetente: null,
                emailremetente:null,
                nomedestinatario:null,
                emaildestinatario:null,
                mensagem:null
            };
            $scope.msgSucessIndique = '';
            $scope.msgErrorIndique = '';

            $scope.resetFormIndique = function(){
                $scope.indique.nomeremetente = null;
                $scope.indique.emailremetente = null;
                $scope.indique.nomedestinatario = null;
                $scope.indique.emaildestinatario = null;
                $scope.indique.mensagem = null;
            }
            $scope.resolveCaptchaIndique = true;
            $scope.enviaContatoIndique = function(formImovelIndique){
                if( !$scope.indique.responserecaptcha){
                    $scope.resolveCaptchaIndique = false;
                    return false;
                }else {
                    $scope.resolveCaptchaIndique = true;
                    if (formImovelIndique.$valid) {
                        $("#ajaxbloq").fadeIn();
                        var obj = {
                            nomeremetente:  $scope.indique.nomeremetente ,
                            emailremetente:$scope.indique.emailremetente,
                            nomedestinatario:$scope.indique.nomedestinatario ,
                            emaildestinatario:$scope.indique.emaildestinatario,
                            recaptcharesponse:$scope.indique.responserecaptcha,
                            mensagem:$scope.indique.mensagem,
                            imovel: {
                                imo_codigo:$scope.imovel.imo_codigo,
                                tic_nome:$scope.imovel.tic_nome,
                                ist_nome:$scope.imovel.ist_nome
                            }
                        };
                        Imovel.enviaContatoIndique(obj).then(function(result){
                            if(result.data.ok){
                                $scope.msgSucessIndique = 'Mensagem Enviada com sucesso!';
                                $scope.msgErrorIndique = '';

                            }else{
                                $scope.msgSucessIndique = '';
                                $scope.msgErroIndiquer = 'Mensagem nÃ£o pode ser enviada tente mais tarde!';
                            }
                            $timeout(function(){
                                $("#msgInfoIndique").fadeOut('slow', function(){
                                    $scope.msgSucessIndique = '';
                                    $scope.msgErrorIndique = '';
                                });
                            }, 5000);
                            formImovelIndique.$setPristine();
                            $scope.resetFormIndique();
                            $("#ajaxbloq").fadeOut();
                        });


                    }else{
                        angular.forEach(formImovelIndique.$error.required, function(value, key){
                            formImovelIndique.$error.required[key].$pristine = false;
                        });
                    }
                }

            }//=============================================
            /*
             CONTATO CORRETOR
             */
            $scope.corretorcontato = {
                nomeremetente: null,
                emailremetente:null,
                mensagem:null
            };
            $scope.msgSucessCorretor = '';
            $scope.msgErrorCorretor = '';

            $scope.resetFormCorretor = function(){
                $scope.corretorcontato.nomeremetente = null;
                $scope.corretorcontato.emailremetente = null;
                $scope.corretorcontato.telefone = null;
                $scope.corretorcontato.mensagem = null;
            }
            $scope.resolveCaptchaCorretor = true;
            
            $scope.enviaContatoCorretor = function(formImovelCorretor){
                if( !$scope.corretorcontato.responserecaptcha){
                    $scope.resolveCaptchaCorretor = false;
                    return false;
                }else {
                    $scope.resolveCaptchaCorretor = true;
                    if (formImovelCorretor.$valid) {
                        $("#ajaxbloq").fadeIn();
                        var obj = {
                            nomeremetente:  $scope.corretorcontato.nomeremetente ,
                            emailremetente:$scope.corretorcontato.emailremetente,
                            recaptcharesponse:$scope.corretorcontato.responserecaptcha,
                            mensagem:$scope.corretorcontato.mensagem,
                            emailcorretor: $scope.imovel.corretor_email,
                            nomecorretor: $scope.imovel.corretor_nome,
                            telefone: $scope.corretorcontato.telefone,
                            imovel: {
                                imo_codigo:$scope.imovel.imo_codigo,
                                tic_nome:$scope.imovel.tic_nome,
                                ist_nome:$scope.imovel.ist_nome
                            }
                        };
                        Imovel.enviaContatoCorretor(obj).then(function(result){
                            if(result.data.ok){
                                $scope.msgSucessCorretor = 'Mensagem Enviada com sucesso!';
                                $scope.msgErrorCorretor = '';

                            }else{
                                $scope.msgSucessCorretor = '';
                                $scope.msgErrorCorretor = 'Mensagem nÃ£o pode ser enviada tente mais tarde!';
                            }
                            $timeout(function(){
                                $("#msgInfoCorretor").fadeOut('slow', function(){
                                    $scope.msgSucessCorretor = '';
                                    $scope.msgErrorCorretor = '';
                                });
                            }, 5000);
                            formImovelCorretor.$setPristine();
                            $scope.resetFormCorretor();
                            $("#ajaxbloq").fadeOut();
                        });


                    }else{
                        angular.forEach(formImovelCorretor.$error.required, function(value, key){
                            formImovelCorretor.$error.required[key].$pristine = false;
                        });
                    }
                }

            }//=============================================

            /*
             Ruggini check
             */
            $scope.checkNullDescricao = function(tabeladepreco){
                var aux = false;
                if (typeof tabeladepreco != 'undefined' && tabeladepreco.length > 0){
                    tabeladepreco.map(function(obj, idx){
                        if(obj.imtp_descricao != ''){
                            aux = true;
                        }
                    });
                }
                return aux;
            }

            /*
             Recaptcha Imovel
             */
            $scope.response = null;
            $scope.widgetId = null;
            $scope.recaptcha = {
                key: '6Le2PxkTAAAAABJWPWIkLPa9QJ-J40XaiZkANGTC'//chave do cliente de seguranÃ§a
            };

            $scope.setResponse = function (response) {
                $scope.contato.recaptcharesponse = response;
            };
            $scope.setWidgetId = function (widgetId) {
                $scope.widgetId = widgetId;
            };
            $scope.cbExpiration = function() {
                vcRecaptchaService.reload($scope.widgetId);
                $scope.contato.recaptcharesponse = null;
            };
            /*
             - Alexandre Modals
             */
            $scope.contentModal = 'formIndique';
            $scope.shareBuilding = false;
            $scope.closeModal = function(){
                $scope.shareBuilding = false;
            }
            $scope.changeContentModal = function(content){
                $scope.contentModal = content;
                $scope.shareBuilding = true;
                if(content == 'formTemporada'){
                    $scope.getIndisponibilidade();
                }
            }

            $scope.resetFormTemporada = function(){
                $scope.temporada = {
                    imoit_datainicial: null,
                    imoit_datafinal: null,
                    imoit_obs: null,
                    imoit_telefone: null,
                    imoit_nome: null,
                    imoit_email:null,
                    recaptcharesponse:null
                };

            }
            $scope.resetFormTemporada();
            $scope.msgErrorTmp = null;
            $scope.msgSuccessTmp = null;
            $scope.$watchGroup(['temporada.imoit_datainicial',
                    'temporada.imoit_datafinal'],
                function(result){
                    if($scope.temporada.imoit_datainicial > $scope.temporada.imoit_datafinal){
                        $scope.temporada.imoit_datafinal = $scope.temporada.imoit_datainicial;
                    }
                });

            $scope.getIndisponibilidade = function(){
                var date = $("#calendar").fullCalendar('getDate');
                if($scope.imovel && $scope.imovel.imo_codigo && new Date(date) != 'Invalid Date'){
                    var obj = {
                        mes: date.format('MM'),//mes 0, 1, 2 soma-se mais 1
                        ano: date.format('YYYY'),
                        imo_codigo:$scope.imovel.imo_codigo
                    }
                    $('#calendar').fullCalendar('removeEvents');
                    Imovel.listTemporada(obj).then(function(data) {
                        if(data.data.itens.length > 0){
                            data.data.itens.map(function(vl, idx){
                                // events.push({title:vl.imoi_nome, start:formatDateTemporada(vl.imoi_datainicial), end:formatDateTemporada(vl.imoi_datafinal)});
                                var obj = {id:vl.imoi_codigo,
                                    textColor:'#000',
                                    backgroundColor:vl.imois_cor,
                                    title:vl.imois_nome,
                                    start:moment(vl.imoi_datainicial).format('YYYY-MM-DD 20:00:00'),
                                    end:moment(vl.imoi_datafinal).format('YYYY-MM-DD 20:00:00'),
                                    allDay:false};

                                $("#calendar").fullCalendar('renderEvent', obj, true);
                            });
                        }
                    });
                }
            }

            $scope.widgetId2 = null;
            $scope.recaptcha2 = {
                key: '6Le2PxkTAAAAABJWPWIkLPa9QJ-J40XaiZkANGTC'//chave do cliente de seguranÃ§a
            };

            $scope.setResponse2 = function (response) {
                $scope.temporada.recaptcharesponse = response;
            };
            $scope.setWidgetId2 = function (widgetId) {
                $scope.widgetId2= widgetId;
            };
            $scope.cbExpiration2 = function() {
                vcRecaptchaService.reload($scope.widgetId2);
                $scope.temporada.recaptcharesponse  = null;
            };
            $scope.resolveCaptcha2 = true;
            $scope.enviaTemporada = function(form) {
                if ($scope.temporada.recaptcharesponse === "") {
                    $scope.resolveCaptcha2 = false;
                    return false;
                } else {
                    /*
                     Quando clica no calendÃ¡rio ele vem com uma data no formato br, ai tem q converter antes de mandar;
                     Funcoes abaixo verificam se esta com 21/02 com barra por exemplo quer dizer que Ã© BR caso contrÃ¡rio passa normal.
                     */
                    function isDateBr(str) {
                        if (typeof str == 'string' && str.indexOf('/')) {
                            return true;
                        } else {
                            return false;
                        }
                    }

                    function formatDate(data) {
                        var str = data.split('/');
                        var date = new Date(str[2] + '-' + str[1] + '-' + str[0]);
                        return date;
                    }

                    if (form.$valid) {
                        $("#ajaxbloq").fadeIn(300);
                        $scope.temporada.imo_codigo = $scope.imovel.imo_codigo;
                        $scope.temporada.imoit_datainicial = (isDateBr($scope.temporada.imoit_datainicial)) ? formatDate($scope.temporada.imoit_datainicial) : $scope.temporada.imoit_datainicial;
                        $scope.temporada.imoit_datafinal = (isDateBr($scope.temporada.imoit_datafinal)) ? formatDate($scope.temporada.imoit_datafinal) : $scope.temporada.imoit_datafinal;
                        Imovel.saveIndisponibilidadeTmp($scope.temporada).then(function (result) {
                            $("#ajaxbloq").fadeOut(300);
                            if (result.data.success) {
                                //notify.addNotification('danger','Salvo com sucesso!');
                                $scope.cbExpiration2();
                                $scope.msgErrorTmp = null;
                                $scope.msgSuccessTmp = result.data.msg;
                                $scope.resetFormTemporada();
                                form.$setPristine();
                                $scope.getIndisponibilidade();

                            } else {
                                //notify.addNotification('danger', result.data.msg);
                                $scope.msgErrorTmp = result.data.msg;
                                $scope.resolveCaptcha2 = false;
                                $scope.msgSuccessTmp = null;
                                $scope.cbExpiration2();
                            }
                        });
                    } else {
                        angular.forEach(form.$error.required, function (value, key) {
                            form.$error.required[key].$pristine = false;
                        });
                    }
                }
            }
            //===================PDF PRINT ==============================

            $scope.b64toBlob = function(b64Data, contentType) {
                contentType = contentType || '';
                var atob_f = window.atob || atob;
                var sliceSize = 512;
                b64Data = b64Data.replace(/^[^,]+,/, '');
                b64Data = b64Data.replace(/\s/g, '');
                var byteCharacters = atob_f(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, {type: contentType});
                return blob;
            }


            $scope.imprimir = function(){
                var pdf = new jsPDF('p', 'cm', 'a4');
                $("#content-imprimir").css('display', 'block');
                pdf.addHTML($("#content-imprimir"),  function() {
                    var string = pdf.output('datauristring');
                    var name = "impressao_imovel_"+$scope.imovel.imo_codigo+".pdf";
                    var blob = $scope.b64toBlob(string);
                    if (window.saveAs) {
                        window.saveAs(blob, name);
                    } else {
                        navigator.saveBlob(blob, name);
                    }
                    $("#content-imprimir").css('display', 'none');
                    //window.open(string);
                });

            }

            /*
             Gera Objeto Simple das fotos Ruggini 26/08/2016
             */
            $scope.getObjfotos = function(objfotos){
                var arr = [];
                for(var i = 0; i < objfotos.length; i++){
                    for(var j = 0; j < objfotos[i].fotos.length; j++){
                        if(objfotos[i].fotos[j].fot_caminho !== '/uploads/imovel/'+$scope.imovel.imo_codigo+'/'+$scope.imovel.fot_caminho){
                            //objfotos[i].fotos[j].principal = true;
                            arr.push(objfotos[i].fotos[j]);
                        }else{
                            // objfotos[i].fotos[j].principal = false;
                        }

                    }
                };
                // console.log(arr);
                return arr;
            }
            /*
             Alexandre 30/08/2016
             */
            $scope.getForm = function(){
                return '/conteudo/formulario/'+$scope.imovel.formlead_codigo+'.html'
            }

            $scope.saveForm = function(form) {
                if (form.$valid) {
                    var arr = {};
                    for (var j in form) {
                        if (j.indexOf("$")) {
                            arr[j] = (form[j].$modelValue) ? form[j].$modelValue : (Array.isArray(form[j])) ? form[j] : null;
                        }
                    }
                    arr['formlead_codigo'] = parseInt(form.$name.substr(8, form.$name.length));
                    arr['imo_codigo'] = $scope.imovel.imo_codigo;
                    console.log('> Valid');
                    Imovel.saveForm(arr).then(function(result) {
                        if (result.data.success) {
                            alert('Obrigado!');
                            $rootScope.responseForm($scope.imovel.imo_codigo);
                            $scope.getRestInfo();
                        }
                    }).catch(function(error) {
                        console.log('>>>>>', error);
                    });

                } else {
                    console.log('> Invalid');
                }
            }
            $scope.teste = false;
            $scope.formlead_response = false;
            $scope.getRestInfo = function() {
                if ($scope.imovel.imo_codigo) {
                    if ($rootScope.checkResponse($scope.imovel.imo_codigo)) {
                        Imovel.getRestInfo($scope.imovel.imo_codigo).then(function(imo) {
                            $scope.imovel = angular.copy(imo.imovel);
                        });
                        $scope.formlead_response = true;
                    }
                }
            }
            $scope.getRestInfo();
            $scope.regModel = function(model, tipo){
                var form = $('body').find("#informacao-restrita form").attr('name');//adiciona no formulario
                form = this[form];
                if(tipo == 'C') {
                    form[model] = null;
                }else if(tipo == 'A'){
                    form[model] = [];
                }
                // console.log($scope);
            }
            $scope.addCheckBox = function(campo, item){
                var form = $('body').find("#informacao-restrita form").attr('name');//adiciona no formulario
                form = this[form];
                var idx = _.findIndex(form[campo], function(o){ return o == item});
                if(idx != -1){
                    form[campo].splice(idx, 1);
                }else{
                    form[campo].push(item);
                }
            }
            $scope.exists = function(campo, item){
                var form = $('body').find("#imovel_info form").attr('name');//adiciona no formulario
                form = this[form];
                var idx = _.findIndex(form[campo], function(o){ return o == item});
                if(idx != -1){
                    return true;
                }else{
                    return false;
                }
            }


            // Ruggini observação de valores 01-09


            $scope.negCondition = false;

            $scope.verifyNegCondition = function(tbl){
                var aux = false;
                //se em alguma das tabelas de preco possui descricao ela vai aparecer como true
                for (var i = 0; i < tbl.length; i++){
                    if(tbl[i].imtp_descricao != '' && tbl[i].imtp_descricao != null){
                        aux = true;
                    }
                }
                $scope.negCondition = aux;
            }

            $scope.newOpen = function(url){
                var imo_codigo = $scope.imovel.imo_codigo.toString();
                var url = url.trim().concat("?imovel=").concat(imo_codigo);
                window.open(url, '_blank');
            }


            // Simulador de Financiamento SAC
            $scope.simF = {
                imo_valor:  500000,
                imoMax_valor: 500000,
                num_parcelas: 4,
                val_entradaP: 10,
                taxa_juros: 2.5,
                mes_parcela: 12,
                mesMax_parcela: 12,
            };

            $scope.setSimFinancValor = function () {
                for (var i=0;i < $scope.imovel.tabeladepreco.length;i++) {
                    if ($scope.imovel.tabeladepreco[i].ttpr_codigo == 1 && $scope.imovel.tabeladepreco[i].imtp_valor > 0) {
                        $scope.simF.imo_valor = $scope.imovel.tabeladepreco[i].imtp_valor
                        $scope.simF.imoMax_valor = $scope.imovel.tabeladepreco[i].imtp_valor
                    }
                }
                $scope.calculaSimFinancValor();
            }
            $scope.calculaSimFinancValor = function() {
                // Formata os valores
                let brReal = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });
                $scope.simF.valorFormat = (brReal.format($scope.simF.imo_valor));
                $scope.simF.mesMax_parcela = $scope.simF.num_parcelas * 12;
                $scope.simF.mes_parcela = 12;
                $scope.simF.val_entradaU =$scope.simF.imo_valor * ($scope.simF.val_entradaP / 100);
                $scope.simF.val_entradaUFormat = brReal.format($scope.simF.val_entradaU);
                $scope.calculaSaldoDevedorSimFinanc();
            }

            $scope.calculaSaldoDevedorSimFinanc = function() {
                let brReal = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });
                let valor_restante = $scope.simF.imo_valor - $scope.simF.val_entradaU;
                $scope.simF.saldo_devedor =  valor_restante;
                $scope.simF.prestacoes = [];
                $scope.simF.valor_total = 0;
                $scope.simF.juros_total = 0;
                let amortizacao = valor_restante / $scope.simF.mesMax_parcela;
                for(let y=0; y<$scope.simF.mesMax_parcela; y++){
                    let juros = (($scope.simF.taxa_juros / 12) / 100) * ( valor_restante - ( y * amortizacao ) );
                    let prestacao = amortizacao + juros;
                    $scope.simF.valor_total += prestacao;
                    $scope.simF.juros_total += juros;
                    // Calcular juros separadamente!
                    $scope.simF.prestacoes.push(prestacao);
                }
                $scope.simF.valor_total = brReal.format($scope.simF.valor_total);
                $scope.simF.juros_total = brReal.format($scope.simF.juros_total);
                $scope.simF.valFirst_parcela = brReal.format($scope.simF.prestacoes[0]);
                $scope.simF.valLast_parcela = brReal.format($scope.simF.prestacoes[$scope.simF.prestacoes.length-1]);
                $scope.updateValorParcela();
            }
            $scope.updateValorParcela = function() {
                let brReal = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });
                $scope.simF.valor_parcela = brReal.format($scope.simF.prestacoes[$scope.simF.mes_parcela-1])
            }
            $scope.setSimFinancValor();

            $scope.simSacBody = false;
            $scope.openBodySimSac = () => {
                $scope.simSacBody = !$scope.simSacBody
            }

            // Simulador de Escritura
            $scope.simE = {
                imo_valor:  500000,
                porc_itbi_site: $scope.imovel.par_valor_itbi_padrao_escritura ? parseFloat($scope.imovel.par_valor_itbi_padrao_escritura) : 2
            };

            $scope.setSimEscritValor = function () {
                for (var i=0;i < $scope.imovel.tabeladepreco.length;i++) {
                    if ($scope.imovel.tabeladepreco[i].ttpr_codigo == 1  && $scope.imovel.tabeladepreco[i].imtp_valor > 0) {
                        $scope.simE.imo_valor = $scope.imovel.tabeladepreco[i].imtp_valor
                    }
                }
                $scope.calculaSimEscritValor();
            }
            $scope.calculaSimEscritValor = function() {
                // Formata os valores
                let brReal = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });
                $scope.simE.imo_valor = $scope.simE.imo_valor > 0 ? $scope.simE.imo_valor : 0;
                $scope.simE.porc_itbi_site = $scope.simE.porc_itbi_site > 0 ? $scope.simE.porc_itbi_site : 0;
                $scope.simE.itbi_valor = $scope.simE.imo_valor * ($scope.simE.porc_itbi_site / 100);
                $scope.simE.tabelionato_valorFormat_valor = $scope.simE.imo_valor * 0.01;
                $scope.simE.registro_valor = $scope.simE.imo_valor * 0.01;
                $scope.simE.valor_total = $scope.simE.itbi_valor + $scope.simE.tabelionato_valorFormat_valor + $scope.simE.registro_valor;
                $scope.simE.valor_totalFormat = (brReal.format($scope.simE.valor_total));
                $scope.simE.valorFormat = (brReal.format($scope.simE.imo_valor));
                $scope.simE.itbi_valorFormat = brReal.format($scope.simE.itbi_valor);
                $scope.simE.tabelionato_valorFormat = brReal.format($scope.simE.tabelionato_valorFormat_valor);
                $scope.simE.registro_valorFormat = brReal.format($scope.simE.registro_valor);
                $scope.simE.imo_valorFormat = (brReal.format($scope.simE.imo_valor));
            }
            $scope.setSimEscritValor();

            $scope.simEscBody = false;
            $scope.openBodySimEsc = () => {
                $scope.simEscBody = !$scope.simEscBody
            }

            $scope.openEsteira = function(){
                $window.location.href = `/esteiraform/${$scope.imovel.imo_codigo}`
            }

            $scope.compartilharWhatsapp = function(){
                texto = encodeURIComponent(`${$scope.imovel.tic_nome}, ${$scope.imovel.ist_nome} - ${$scope.imovel.og.url}`);
                let url = `https://api.whatsapp.com/send?text=${texto}`;
                window.open(url, '_blank');
            }
            
            $scope.compartilharFacebook = function(){
                let link = encodeURIComponent($scope.imovel.og.url);
                let url = `https://www.facebook.com/sharer/sharer.php?u=${link}`;
                // Definir as dimensões da janela pop-up
                let popupWidth = 600;
                let popupHeight = 400;
                // Calcular a posição central da tela para a pop-up
                let left = (screen.width / 2) - (popupWidth / 2);
                let top = (screen.height / 2) - (popupHeight / 2);
                // Abrir em uma nova janela com dimensões e posição especificadas
                window.open(url, 'sharer', `width=${popupWidth},height=${popupHeight},top=${top},left=${left}`);
            }
            

        }]);



        // Traduzindo a variável temos:
        // PV = Present Value = Valor Presente = vP
        
        // PRICE
        //     pmt .push( vP * ( Math.pow((1+i),n) * i ) / ( Math.pow((1+i),n) -1 ) );
        
        // SAC
        //   > amortização =  a = VP /n
        //   > ( k - 1 ) x i  = é o período analisado que será abstraído tornando-se ( y )
        //   > 1a parcela = a + i * VP
        //   > 2a parcela = a + i * ( VP -  1 * a )
        //   > 3a parcela = a + i * ( VP -  2 * a )

    app.directive('fullCalendarTemporada', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var locale = $('#routesJSON').data('routesjson');
                var config = angular.extend({
                    lang: locale,
                    header: {
                        left: 'prevYear,prev,today,next,nextYear',
                        center: 'title',
                        right: false
                    },
                    viewRender: function (view, element) {
                        scope.getIndisponibilidade();
                    },
                    editable: false,
                    droppable: false,
                    defaultView: 'month',
                    eventClick: function(calEvent, jsEvent, view) {
                        //scope.getEdtIndisponibilidade(calEvent.id);
                    },
                    dayClick: function(date, jsEvent, view) {
                        function parseDate(input) {
                            var parts = input.match(/(\d+)/g);
                            // new Date(year, month [, date [, hours[, minutes[, seconds[, ms]]]]])
                            return new Date(parts[0], parts[1]-1, parts[2]); // months are 0-based
                        }
                        scope.$apply(function () {
                            scope.temporada.imoit_datainicial =  parseDate(date.format('YYYY-MM-DD'));
                            scope.temporada.imoit_datafinal =  parseDate(date.format('YYYY-MM-DD'));
                            // scope.temporada.acao = 'cadindisponibilidade';
                        });
                    }
                });


                   element.fullCalendar(config);



            }
        }
    });
});

